// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#move-room-schedule-register .note[data-v-12cb6f4e]{margin:0 0 20px 20px}#move-room-schedule-register .box-footer[data-v-12cb6f4e]{padding:10px 0 0 0!important}#move-room-schedule-register .cancel-btn[data-v-12cb6f4e],#move-room-schedule-register .register-btn[data-v-12cb6f4e]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
